import $ from "jquery";


const employmentPage = $('.employment-page');

function positionActiveJob() {
  if (window.innerWidth > 1280) {
    $('.employment-page__nav-link.is-active').trigger('click');
  }
} 

if (employmentPage.length !== 0) {  
  $(window).on('resize', positionActiveJob);
}